import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { UiDateTimeRangePickerComponent } from './date-time-range-picker.component';
import { UiDateRangeQuickHeaderModule } from '@netfoundry-ui/ui/date-range-quick-header';

@NgModule({
    imports: [CommonModule, OverlayModule, MatIconModule, MatDatepickerModule, MatNativeDateModule, UiDateRangeQuickHeaderModule],
    declarations: [UiDateTimeRangePickerComponent],
    exports: [UiDateTimeRangePickerComponent],
})
export class UiDateTimeRangePickerModule {}

